"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bi_logger_groups_1 = require("bi-logger-groups");
var web_bi_logger_1 = require("web-bi-logger");
function getBiLogger(biLoggerData) {
    if (biLoggerData === void 0) { biLoggerData = {}; }
    return bi_logger_groups_1.default(biLoggerData.biLoggerFactory || web_bi_logger_1.default)({
        defaults: getBIDefaults(biLoggerData),
    });
}
exports.getBiLogger = getBiLogger;
function getBIDefaults(_a) {
    var biParams = _a.biParams, viewMode = _a.viewMode, _b = _a.pageName, pageName = _b === void 0 ? null : _b, _c = _a.componentName, componentName = _c === void 0 ? null : _c;
    var defaults = {
        pageName: pageName,
        componentName: componentName,
    };
    if (biParams) {
        defaults._msid = biParams.metaSiteId;
        defaults._visitorId = viewMode === 'Site' ? biParams.visitorId : null;
        defaults._uuid = biParams.ownerId;
    }
    if (viewMode) {
        defaults.userEntry =
            viewMode === 'Dashboard' ? 'bizmngr' : viewMode.toLowerCase();
    }
    return defaults;
}
exports.getBIDefaults = getBIDefaults;
//# sourceMappingURL=BiLogger.js.map